<!-- start banner Area -->
<section class="top-banner mb-4">
  <div class="top-banner-img" style="">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1 style="padding: 30px 0px 0px 0px !important;"> Mes sauvegardes</h1>
          <p class="text-white link-nav"><a [routerLink]="['/accueil', 'candidat']"
              style="color: #ff5a00 !important">Accueil</a> <span class="lnr lnr-arrow-right"></span>
            <span> mes sauvegardes</span>
          </p>

        </div>
      </div>
    </div>
  </div>
</section>
<!-- End banner Area -->
<!-- Start service Area -->
<section class="service-area section-gap" id="service">
  <div class="container">
    <div class="row pb-40">

      <!-- Alert d'emploi -->
      <div class="col-md-6 mb-5">
        <fieldset class="form-area fieldset-panel min-h-340">
          <legend class="legend-style" style="width: 50%;">Alerte d'emploi </legend>
          <form [formGroup]="jobAlertForm" (ngSubmit)="onSubmitJobAlertForm()">
            <div class="row">
              <div class="form-group col-md-6">
                <label for="profession">Métier <span class="star-style">**</span></label>
                <select class="form-control" id="profession" formControlName="profession_id">
                  <option value="">Selectionner...</option>
                  <option [value]="profession.getId()" *ngFor="let profession of professionList">{{
                    profession.getLibelle() }}</option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label for="years_of_experience">Année d'expérience <span class="star-style">**</span></label>
                <select class="form-control" id="years_of_experience" formControlName="years_of_experience">
                  <option value="">Selectionner...</option>
                  <option value="Sans experience">Sans experience</option>
                  <option value="Moins d'un an">Moins d'un an</option>
                  <option value="1 à 2ans">1 à 2ans</option>
                  <option value="3 à 5ans">3 à 5ans</option>
                  <option value="6 à 10ans">6 à 10ans</option>
                  <option value="Plus de 10ans">Plus de 10ans</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6">
                <label for="training">Formation <span class="star-style">**</span></label>
                <select class="form-control" id="training" formControlName="training_id">
                  <option value="">Selectionner...</option>
                  <option [value]="training.getId()" *ngFor="let training of trainingList">{{ training.getLibelle() }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label for="level_of_study">Niveau d'étude <span class="star-style">**</span></label>
                <select class="form-control" id="level_of_study" formControlName="level_of_study">
                  <option value="">Selectionner...</option>
                  <option value="Secondaire">Secondaire</option>
                  <option value="Terminal">Terminale</option>
                  <option value="Formation professionnelle">Formation professionnelle</option>
                  <option value="Baccalauréat">Baccalauréat</option>
                  <option value="Universitaire sans diplôme">Universitaire sans diplôme</option>
                  <option value="BAC + 2">BAC + 2</option>
                  <option value="Licence(BAC + 3)">Licence (BAC + 3)</option>
                  <option value="Master 1(BAC + 4)">Master 1 (BAC + 4)</option>
                  <option value="Master 2(BAC + 5)">Master 2 (BAC + 2)</option>
                  <option value="Doctorat(BAC + 7)">Doctorat (BAC + 7)</option>
                </select>
              </div>
            </div>
            <button type="submit" class="primary-btn text-white" [disabled]="jobAlertForm.invalid"
              *ngIf="!jobAlertIsLoading">Ajouter</button>
            <p class="text-danger" style="padding-top: 15px; margin-left: 15px;" *ngIf="jobAlertIsLoading">Veuillez
              patienter...
            </p>

            <!-- Div block afficher/reduire -->
            <div id="jobAlertBlock" style="display: none">
              <!-- Liste des alerts -->
              <div class="form-group mt-5" style="width: 100%; overflow: auto;">
                <table class="table table-bordered">
                  <tr>
                    <th>Métier</th>
                    <th>Année d'expérience</th>
                    <th>Formation</th>
                    <th>Niveau d'étude</th>
                    <th>Action</th>
                  </tr>
                  <tr *ngFor="let candidateJobAlert of CandidatesJobsAlertList">
                    <td>{{ candidateJobAlert.getProfessions()['libelle'] }}</td>
                    <td>{{ candidateJobAlert.getYearsOfExperience() }}</td>
                    <td>{{ candidateJobAlert.getTrainings()['libelle'] }}</td>
                    <td>{{ candidateJobAlert.getLevelOfStudy() }}</td>
                    <td><span class="btn btn-danger" (click)="removeJobAlert(candidateJobAlert.getId())">Supp</span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <!-- Label block afficher/reduire -->
            <div id="jobAlertLabelToShowOrHide" class="labelBlock"
              (click)="functionsService.showOrHideBlock('jobAlertBlock', 'jobAlertLabelToShowOrHide')">
              Afficher plus
            </div>
          </form>
        </fieldset>
      </div>

      <!-- Alert de formation -->
      <div class="col-md-6 mb-5">
        <fieldset class="form-area fieldset-panel min-h-340">
          <legend class="legend-style" style="width: 50%;">Alerte de formation </legend>
          <form [formGroup]="educationAlertForm" (ngSubmit)="onSubmitEducationAlertForm()">
            <div class="form-group">
              <label for="trainingCategory">Catégorie de formation <span class="star-style">**</span></label>
              <select class="form-control" formControlName="category">
                <option value="">Selectionner...</option>
                <option value="{{ educationCategory['id'] }}" *ngFor="let educationCategory of educationCategoriesList">
                  {{ educationCategory['title'] }}</option>
              </select>
            </div>
            <button type="submit" class="primary-btn text-white" [disabled]="educationAlertForm.invalid"
              *ngIf="!educationAlertIsLoading">Ajouter</button>
            <p class="text-danger" style="padding-top: 15px; margin-left: 15px;" *ngIf="educationAlertIsLoading">
              Veuillez patienter...
            </p>

            <!-- Div block afficher/reduire -->
            <div id="trainingAlertBlock" style="display: none">
              <!-- Liste des alerts -->
              <div class="form-group mt-5" style="width: 100%; overflow: auto;">
                <table class="table table-bordered">
                  <tr>
                    <th>Catégorie</th>
                    <th>Action</th>
                  </tr>
                  <tr *ngFor="let candidateEducationAlert of candidatesEducationsAlertList">
                    <td>{{ candidateEducationAlert.getEducationsCategories()['title'] }}</td>
                    <td><span class="btn btn-danger"
                        (click)="removeEducationAlert(candidateEducationAlert.getId())">Supp</span></td>
                  </tr>
                </table>
              </div>
            </div>

            <!-- Label block afficher/reduire -->
            <div id="trainingAlertLabelToShowOrHide" class="labelBlock"
              (click)="functionsService.showOrHideBlock('trainingAlertBlock', 'trainingAlertLabelToShowOrHide')">
              Afficher plus
            </div>
          </form>
        </fieldset>
      </div>

      <!-- Offres d'emploi sauvegardé -->
      <div class="col-md-12 mb-5">
        <h4 class="mb-3">Offres d'emploi sauvegardées</h4>

        <div class="col-lg-12 post-list" style="margin-left: -15px;">
          <p *ngIf="jobList.length == 0"> Aucune offre d'emploi trouvée. </p>
          <div class="single-post d-flex flex-row w-100 height-fixe" *ngFor="let job of jobList">
            <div class="thumb mr-4">
              <img src="assets/img/post.png" alt="" class="company-logo">
            </div>
            <div class="details" style="width: 80%;">
              <div class="title d-flex flex-row justify-content-between">
                <div class="titles" style="font-weight: bold;">
                  <a href="#">
                    <h5>{{ functionsService.wordWrap(job.getLibelle(), 50) }}</h5>
                  </a>
                  <h6>{{ job.getCompany()['acronym'] }}</h6>
                </div>
              </div>
              <p>
                La société {{ job.getCompany()['acronym'] }} recherche un profil comme tel :
              </p>
              <div class="address"><span class="lnr lnr-license"></span> <span
                  *ngFor="let training of job.getJobsTrainings()">
                  {{ training.getLevelOfStudy() }} en {{ training.getTraining()['libelle'] }} | </span> </div>
              <div class="address"><span class="lnr lnr-calendar-full"></span> {{ job.getYearOfExperience() }} <span
                  *ngIf="job.getYearOfExperience() != 'Sans expérience'">d'expériences</span>, <span
                  class="lnr lnr-map-marker"></span> {{ job.getCity() }}, {{ job.getCountry() }} </div>
              <a [routerLink]="['/offres-emploi', job.getId()]">Détails</a>
              <div class="address d-flex my-4">
                <button class="mr-3 button-btn" (click)="removeBackupJob(job.getId())">Supprimer</button>
                <a [routerLink]="['/postuler', job.getId()]"><button class="button-btn">Postuler</button></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End service Area -->